import { useState } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import queryString from 'query-string'
import s from './PageMenu.scss'
import cn from 'classnames'
import { InputContainer } from 'components/ideal-core-ui'
import { FaPlusSquare, FaMinusSquare } from 'react-icons/fa'

const PageMenu = ({
  page,
  setPage,
  menu,
  subPageOpened,
  withUpdateUrl,
  expandAll,
  withRoutes,
  sticky,
  withSearch
}) => {
  const [isOpened, setIsOpened] = useState(subPageOpened)
  const [prevIsOpened, setPrevIsOpened] = useState(subPageOpened)
  const [searchTerm, setSearchTerm] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  if (prevIsOpened !== subPageOpened) {
    setPrevIsOpened(subPageOpened)
    setIsOpened(subPageOpened)
  }

  const toggleMenuItem = (item, isSubmenu, mainItem) => {
    if (!withRoutes) {
      setPage(item.key)
      withUpdateUrl && updateQueryParam(item.key)
    }

    isSubmenu ? mainItem && setIsOpened(mainItem.key) : setIsOpened('')
  }

  const updateQueryParam = key => {
    const search = queryString.parse(location.search)
    search.menu = key
    if (search.secondaryTab) delete search.secondaryTab
    navigate({ search: queryString.stringify(search) })
  }

  const getItem = (item, isSubmenu, mainItem) =>
    !withRoutes ? (
      <p
        key={item.key}
        className={cn(s.menuItem, {
          [s.active]: page === item.key
        })}
        onClick={() => {
          toggleMenuItem(item, isSubmenu, mainItem)
        }}
        data-cy={`${item.key}_tab`}
      >
        {item.icon || ''} {item.text}
      </p>
    ) : (
      <Link to={item.path} key={item.key}>
        <p
          className={cn(s.menuItem, {
            [s.active]: page === item.key
          })}
          onClick={() => {
            toggleMenuItem(item, isSubmenu, mainItem)
          }}
          data-cy={`${item.key}_tab`}
        >
          {item.icon || ''} {item.text}
        </p>
      </Link>
    )

  return (
    <div className={sticky ? s.sticky : ''}>
      <>
        {withSearch && (
          <InputContainer
            type="text"
            text={searchTerm}
            placeholder="Search for report"
            cb={value => setSearchTerm(value)}
            classname={s.addItemInput}
          />
        )}
        {menu
          .filter(item => !item.hide)
          .map(item => {
            return item.submenu ? (
              <div className={s.parent} key={item.key}>
                <p
                  className={cn(s.menuItem, s.header, {
                    [s.active]: isOpened === item.key
                  })}
                  onClick={() => {
                    setIsOpened(isOpened === item.key ? '' : item.key)
                    !withRoutes && setPage(item.submenu[0].key)
                  }}
                >
                  {isOpened === item.key ? <FaMinusSquare /> : <FaPlusSquare />} {item.text}
                </p>
                {(expandAll || item.key === isOpened) &&
                  item.submenu
                    .filter(s => s.text.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map(i => getItem(i, true, item))}
              </div>
            ) : (
              getItem(item)
            )
          })}
      </>
    </div>
  )
}

export default PageMenu
